export default __webpack_public_path__ + "static/media/dai.24cfe4e5.svg";